<template>
  <div class="font-sans bg-[#f6f4f1] text-[#1f2937] min-h-screen flex flex-col">
    <AppHeader />

    <div class="max-w-4xl mx-auto px-4 py-10 w-full">
      <h1 class="text-3xl font-bold mb-8 text-center">Meu Perfil</h1>

      <div class="bg-white shadow-xl rounded-2xl p-6 md:p-10 space-y-8">

        <!-- AVATAR -->
        <div class="flex justify-center">
          <AvatarUploader
            v-model="previewImage"
            @file-selected="file => (attachmentFile = file)"
          />
        </div>

        <!-- CAMPOS -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

          <div>
            <label class="font-medium">Nome</label>
            <input v-model="form.name" class="input-gold mt-1" />
          </div>

          <div>
            <label class="font-medium">Headline</label>
            <input
              v-model="form.headline"
              maxlength="120"
              placeholder="Ex.: Desenvolvedor Full Stack"
              class="input-gold mt-1"
            />
          </div>

          <div class="md:col-span-2">
            <label class="font-medium">Bio</label>
            <textarea
              v-model="form.bio"
              rows="4"
              class="input-gold mt-1"
              placeholder="Conte um pouco sobre você..."
            ></textarea>
          </div>

          <div>
            <label class="font-medium">Nível</label>
            <select v-model="form.experience_level" class="input-gold mt-1">
              <option disabled value="">Selecione</option>
              <option value="junior">Júnior</option>
              <option value="pleno">Pleno</option>
              <option value="senior">Sênior</option>
            </select>
          </div>

          <div>
            <label class="font-medium">Experiência Profissional</label>
            <textarea
              v-model="form.professional_experience"
              rows="4"
              class="input-gold mt-1"
            ></textarea>
          </div>

          <!-- SKILLS -->
          <!-- ✅ SUBSTITUA APENAS A SEÇÃO SKILLS DO TEMPLATE POR ESTA -->
<!-- SKILLS -->
<div class="md:col-span-2">
  <label class="font-medium">Habilidades</label>

  <!-- chips selecionadas -->
  <div v-if="form.skills.length" class="flex flex-wrap gap-2 mt-2">
    <div
      v-for="(skill, index) in form.skills"
      :key="skill.id ?? `${skill.description}-${index}`"
      class="bg-[#1a1a1a] text-white px-3 py-1 rounded-full flex items-center gap-2"
    >
      <span class="text-sm">{{ skill.description }}</span>
      <button @click="removeSkill(index)" class="text-red-400 text-sm">×</button>
    </div>
  </div>

  <!-- busca -->
  <div class="mt-2 relative">
    <input
      v-model="skillSearch"
      type="text"
      placeholder="Digite para buscar habilidades..."
      class="input-gold"
    />

    <!-- dropdown -->
    <div
      v-if="skillOptions.length"
      class="absolute z-20 mt-2 w-full bg-white border rounded-xl max-h-56 overflow-auto shadow"
    >
      <button
        v-for="opt in skillOptions"
        :key="opt.id"
        type="button"
        class="w-full text-left px-3 py-2 hover:bg-gray-50 text-sm"
        @click="addSkillFromOption(opt)"
      >
        {{ opt.description }}
      </button>
    </div>

    <p v-if="skillSearch.trim().length >= 2 && !skillOptions.length && !skillLoading"
       class="text-xs text-gray-500 mt-2">
      Nenhuma habilidade encontrada.
    </p>

    <p v-if="skillLoading" class="text-xs text-gray-500 mt-2">
      Buscando...
    </p>
  </div>
</div>
        </div>

        <!-- BOTÃO DE CONFIRMAÇÃO -->
        <div class="flex justify-end">
          <button
            @click="confirmUpdate"
            :disabled="loading"
            class="px-6 py-3 rounded-xl bg-[#1a1a1a] text-white disabled:opacity-40 mt-4"
          >
            {{ loading ? "Atualizando..." : "Atualizar Cadastro" }}
          </button>
        </div>
      </div>

      <!-- SEÇÃO: PERFIL DE PRESTADOR PRESENCIAL -->
      <div class="bg-white shadow-xl rounded-2xl p-6 md:p-10 mt-6">
        <h2 class="text-xl font-bold text-[#152a34] mb-1">Perfil de Prestador</h2>
        <p class="text-sm text-gray-500 mb-6">Configure sua atuação como prestador de serviços presenciais.</p>

        <div v-if="providerForm.provider_type !== 'remote' && (!providerForm.latitude || !providerForm.longitude)" class="mb-6 p-4 bg-amber-50 border border-amber-200 rounded-xl text-amber-800 text-sm">
          Para aparecer na busca de prestadores presenciais, informe o CEP de atuação abaixo e clique em Salvar.
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="md:col-span-2">
            <label class="font-medium block mb-2">Tipo de Atuação</label>
            <div class="flex gap-3 flex-wrap">
              <label v-for="opt in providerTypeOptions" :key="opt.value" class="flex items-center gap-2 cursor-pointer px-4 py-2 rounded-xl border transition"
                :class="providerForm.provider_type === opt.value ? 'bg-[#152a34] text-white border-[#152a34]' : 'bg-white border-gray-200 hover:border-[#b99a52]'">
                <input type="radio" v-model="providerForm.provider_type" :value="opt.value" class="sr-only" />
                {{ opt.label }}
              </label>
            </div>
          </div>

          <template v-if="providerForm.provider_type !== 'remote'">
            <div>
              <label class="font-medium block mb-1">CEP de Atuação</label>
              <div class="flex gap-2">
                <input
                  v-model="providerForm.zipCode"
                  @input="onCepInput"
                  @blur="onCepBlur"
                  type="text"
                  placeholder="00000-000"
                  maxlength="9"
                  class="input-gold flex-1"
                />
                <button
                  type="button"
                  @click="runFetchProviderCep"
                  :disabled="cepLoading"
                  class="px-3 py-2 bg-[#152a34] text-white rounded-xl text-sm hover:bg-[#1e3a4a] transition disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center min-w-[44px]"
                >
                  <span v-if="cepLoading" class="mdi mdi-loading animate-spin"></span>
                  <span v-else class="mdi mdi-magnify"></span>
                </button>
              </div>
            </div>

            <div>
              <label class="font-medium block mb-1">Raio de Atuação: <strong>{{ providerForm.service_radius_km }} km</strong></label>
              <input v-model="providerForm.service_radius_km" type="range" min="5" max="100" step="5" class="w-full accent-[#b99a52]" />
              <div class="flex justify-between text-xs text-gray-400 mt-1">
                <span>5 km</span><span>100 km</span>
              </div>
            </div>

            <div v-if="providerForm.service_address" class="md:col-span-2 p-3 bg-[#f4efe6] rounded-xl text-sm text-[#152a34]">
              <p class="font-medium">Endereço de atuação:</p>
              <p class="text-gray-600">{{ providerForm.service_address.address }}, {{ providerForm.service_address.neighborhood }} — {{ providerForm.service_address.city }}/{{ providerForm.service_address.state }}</p>
            </div>
          </template>
        </div>

        <div v-if="providerMsg" :class="['mt-4 p-3 rounded-xl text-sm', providerError ? 'bg-red-50 text-red-600' : 'bg-green-50 text-green-700']">
          {{ providerMsg }}
        </div>

        <button @click="saveProviderProfile" :disabled="savingProvider"
          class="mt-5 px-6 py-3 rounded-xl bg-[#b99a52] text-white font-semibold hover:bg-[#a08840] transition disabled:opacity-50 flex items-center gap-2">
          <span v-if="savingProvider" class="mdi mdi-loading animate-spin"></span>
          {{ savingProvider ? 'Salvando...' : 'Salvar Perfil de Prestador' }}
        </button>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
import api from "@/services/api";
import { updateProviderLocation } from "@/services/api";
import { useProviderOnboardingStore } from "@/store/providerOnboardingStore";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AvatarUploader from "@/components/AvatarUploader.vue";
import { useRouter } from "vue-router";

const router = useRouter();
const { proxy } = getCurrentInstance();
const onboardingStore = useProviderOnboardingStore();

const previewImage = ref(null);
const attachmentFile = ref(null);
const loading = ref(false);

const form = ref({
  id: "",
  name: "",
  headline: "",
  bio: "",
  experience_level: "",
  professional_experience: "",
  skills: [], // [{id, description}]
});

/* -----------------------------
   ✅ AUTOCOMPLETE DE SKILLS (categories)
------------------------------ */
const skillSearch = ref("");
const skillOptions = ref([]); // [{id, description}]
const skillLoading = ref(false);
let skillTimer = null;

watch(skillSearch, (val) => {
  clearTimeout(skillTimer);
  const term = String(val || "").trim();

  // se limpar ou muito curto, limpa dropdown
  if (term.length < 2) {
    skillOptions.value = [];
    skillLoading.value = false;
    return;
  }

  skillTimer = setTimeout(async () => {
    await searchSkills(term);
  }, 250);
});

async function searchSkills(term) {
  try {
    skillLoading.value = true;
    const { data } = await api.get("/categories", {
      params: { search: term, limit: 20 },
    });

    const list = data?.data || [];

    // remove as já selecionadas (por id quando tiver; senão por descrição)
    const selectedIds = new Set(form.value.skills.filter(s => s?.id != null).map(s => s.id));
    const selectedDesc = new Set(form.value.skills.map(s => String(s.description || "").toLowerCase()));

    skillOptions.value = list.filter((opt) => {
      const descKey = String(opt.description || "").toLowerCase();
      if (opt.id != null && selectedIds.has(opt.id)) return false;
      if (selectedDesc.has(descKey)) return false;
      return true;
    });
  } catch (e) {
    skillOptions.value = [];
  } finally {
    skillLoading.value = false;
  }
}

function addSkillFromOption(opt) {
  if (!opt) return;

  // evita duplicado (id primeiro, depois descrição)
  const exists = form.value.skills.some((s) => {
    if (s.id != null && opt.id != null) return s.id === opt.id;
    return String(s.description || "").toLowerCase() === String(opt.description || "").toLowerCase();
  });

  if (!exists) {
    form.value.skills.push({ id: opt.id ?? null, description: opt.description });
  }

  // limpa busca / dropdown
  skillSearch.value = "";
  skillOptions.value = [];
}

function removeSkill(i) {
  form.value.skills.splice(i, 1);
}

/* -----------------------------
   ✅ IMAGEM / ATTACHMENT (SEU CÓDIGO)
------------------------------ */
function buildStorageUrl(rawPath) {
  if (!rawPath) return null;
  const maybe = String(rawPath);

  if (/^(https?:)?\/\//i.test(maybe)) {
    try { return encodeURI(maybe); } catch { return maybe; }
  }

  const baseRaw = process.env.VUE_APP_URL_API_STORAGE || "";
  const base = String(baseRaw).replace(/\/+$/, "");

  const normalized = maybe.replace(/\\/g, "/").replace(/^\/+/, "").replace(/\/+/g, "/");
  const final = base ? `${base}/${normalized}` : `/${normalized}`;

  try { return encodeURI(final); } catch { return final; }
}

function resolveAttachmentPreview(attachmentField) {
  if (!attachmentField) return null;

  if (typeof attachmentField === "object" && !Array.isArray(attachmentField)) {
    if (attachmentField.url) return buildStorageUrl(attachmentField.url);
  }

  if (Array.isArray(attachmentField) && attachmentField.length > 0) {
    return buildStorageUrl(attachmentField[0]);
  }

  if (typeof attachmentField === "string") {
    return buildStorageUrl(attachmentField);
  }

  return null;
}

/* -----------------------------
   ✅ LOAD USER
------------------------------ */
onMounted(async () => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  if (!userData || !userData.user?.id) {
    router.push("/");
    return;
  }

  await loadUserData()
  await loadProviderData()
});

async function loadProviderData () {
  try {
    const { data } = await api.get('/users/profile')
    const u = data.data || data
    providerForm.value.provider_type = u.provider_type || 'remote'
    providerForm.value.service_radius_km = u.service_radius_km || 20
    providerForm.value.latitude = u.latitude || null
    providerForm.value.longitude = u.longitude || null
    if (u.service_address) {
      const addr = typeof u.service_address === 'string' ? JSON.parse(u.service_address) : u.service_address
      providerForm.value.service_address = addr
      providerForm.value.zipCode = formatCep(addr?.zip_code || '') || ''
    }
  } catch {}
}

async function loadUserData() {
  try {
    const { data } = await api.get("/users/profile");
    const u = data.data || data;

    form.value = {
      id: u.id,
      name: u.name,
      headline: u.headline || "",
      bio: u.bio || "",
      experience_level: u.experience_level || "",
      professional_experience: u.professional_experience || "",
      skills: Array.isArray(u.skills)
        ? u.skills.map((s) =>
            typeof s === "string" ? { id: null, description: s } : { id: s.id ?? null, description: s.description }
          )
        : [],
    };

    let attachmentField = u.attachment;

    if (typeof attachmentField === "string") {
      const maybeTrim = attachmentField.trim();
      if (maybeTrim.startsWith("[") || maybeTrim.startsWith("{")) {
        try { attachmentField = JSON.parse(attachmentField); } catch {}
      }
    }

    const preview = resolveAttachmentPreview(attachmentField);
    if (preview) previewImage.value = preview;
  } catch (error) {
    console.error("Erro ao carregar perfil:", error);
    proxy.$swal.fire({ icon: "error", title: "Erro ao carregar perfil" });
  }
}

/* -----------------------------
   ✅ UPDATE PROFILE (SEU CÓDIGO)
------------------------------ */
async function updateProfile() {
  loading.value = true;

  try {
    const payload = new FormData();
    payload.append("name", form.value.name);
    payload.append("headline", form.value.headline);
    payload.append("bio", form.value.bio);
    payload.append("experience_level", form.value.experience_level);
    payload.append("professional_experience", form.value.professional_experience);

    // mantém compatível com seu backend atual:
    payload.append("skills", JSON.stringify(form.value.skills));

    if (attachmentFile.value) payload.append("attachment[]", attachmentFile.value);

    await api.post(`/users/${form.value.id}`, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    proxy.$swal.fire({ icon: "success", title: "Perfil atualizado!" });

    await loadUserData();
    attachmentFile.value = null;
  } catch (err) {
    console.error("Erro ao atualizar perfil:", err);
    proxy.$swal.fire({
      icon: "error",
      title: "Erro ao atualizar",
      text: err?.response?.data?.error || "Tente novamente.",
    });
  } finally {
    loading.value = false;
  }
}

function confirmUpdate() {
  proxy.$swal
    .fire({
      title: "Atualizar Cadastro?",
      text: "Deseja salvar as alterações?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim, atualizar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "swal2-confirm-btn-custom",
        cancelButton: "swal2-cancel-btn-custom",
      },
    })
    .then((res) => {
      if (res.isConfirmed) updateProfile();
    });
}

// ========================
// PERFIL DE PRESTADOR V2
// ========================
const providerTypeOptions = [
  { label: 'Somente Remoto', value: 'remote' },
  { label: 'Somente Presencial', value: 'presential' },
  { label: 'Ambos', value: 'both' },
]

const providerForm = ref({
  provider_type: 'remote',
  service_radius_km: 20,
  latitude: null,
  longitude: null,
  service_address: null,
  zipCode: '',
})

const savingProvider = ref(false)
const providerMsg = ref('')
const providerError = ref(false)
const cepLoading = ref(false)

function formatCep (value) {
  const digits = String(value || '').replace(/\D/g, '')
  if (digits.length <= 5) return digits
  return digits.slice(0, 5) + '-' + digits.slice(5, 9)
}

function onCepInput (e) {
  const formatted = formatCep(e.target.value)
  providerForm.value.zipCode = formatted
}

function onCepBlur () {
  runFetchProviderCep()
}

async function runFetchProviderCep () {
  if (cepLoading.value) return
  const cep = providerForm.value.zipCode.replace(/\D/g, '')
  if (cep.length !== 8) return
  cepLoading.value = true
  try {
    await fetchProviderCep()
  } finally {
    cepLoading.value = false
  }
}

async function fetchProviderCep () {
  const cep = providerForm.value.zipCode.replace(/\D/g, '')
  if (cep.length !== 8) return
  try {
    const { data } = await api.get(`/cep?cep=${cep}`)
    if (data && !data.erro) {
      const addr = {
        zip_code: cep,
        address: data.logradouro || '',
        neighborhood: data.bairro || '',
        city: data.localidade || '',
        state: data.uf || ''
      }
      providerForm.value.service_address = addr

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos) => {
          providerForm.value.latitude = pos.coords.latitude
          providerForm.value.longitude = pos.coords.longitude
        })
      }
    }
  } catch {}
}

function buildAddressString (addr) {
  if (!addr || typeof addr !== 'object') return ''
  const parts = [addr.address, addr.neighborhood, addr.city, addr.state, 'Brasil'].filter(Boolean)
  return parts.join(', ')
}

async function geocodeAddressToLatLng (addressString) {
  const key = process.env.VUE_APP_GOOGLE_MAPS_API_KEY
  if (!key || !addressString.trim()) return null
  try {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(addressString)}&key=${key}&language=pt-BR`
    const res = await fetch(url)
    const data = await res.json()
    if (data.status === 'OK' && data.results && data.results[0]) {
      const loc = data.results[0].geometry.location
      return { lat: loc.lat, lng: loc.lng }
    }
  } catch {}
  return null
}

async function saveProviderProfile () {
  providerMsg.value = ''
  providerError.value = false
  savingProvider.value = true
  try {
    let lat = providerForm.value.latitude
    let lng = providerForm.value.longitude
    const addr = providerForm.value.service_address

    if (addr && (lat == null || lng == null)) {
      const addressString = buildAddressString(addr)
      const coords = await geocodeAddressToLatLng(addressString)
      if (coords) {
        lat = coords.lat
        lng = coords.lng
        providerForm.value.latitude = lat
        providerForm.value.longitude = lng
      }
    }

    const payload = {
      provider_type: providerForm.value.provider_type,
      service_radius_km: providerForm.value.service_radius_km,
    }
    if (lat != null) payload.latitude = lat
    if (lng != null) payload.longitude = lng
    if (addr) payload.service_address = addr

    await updateProviderLocation(payload)
    onboardingStore.refresh()
    providerMsg.value = 'Perfil de prestador atualizado com sucesso!'
  } catch (err) {
    providerError.value = true
    providerMsg.value = err?.response?.data?.error || 'Erro ao atualizar.'
  } finally {
    savingProvider.value = false
  }
}


</script>

<style>
.swal2-cancel-btn-custom {
  color: #1f2937 !important;
  border: 1px solid #9ca3af !important;
  background-color: #ffffff !important;
}

.swal2-cancel-btn-custom:hover {
  background-color: #f3f4f6 !important;
}

.swal2-confirm-btn-custom {
  color: #ffffff !important;
  /* ← TEXTO BRANCO */
  background-color: #1a1a1a !important;
  border: none !important;
}

.swal2-confirm-btn-custom:hover {
  background-color: #000000 !important;
}
</style>
